import { DatePipe } from '@angular/common';
import { Component } from '@angular/core';
import { UserModel } from 'app/_models/user-model';
import { CommonservicesService } from 'app/_services/commonservices.service';
import { CrudPurchaseOrderService } from 'app/_services/MasterCrudOps/crud-purchase-order.service';
import { NotificationService } from 'app/_services/notification.service';
import { SpreadsheetValidateService } from 'app/_services/spreadsheetValidation.service';
import { SpreadsheetFileHandler } from 'app/core/handlers/spreadsheet-file-handler';

@Component({
  selector: 'app-bulk-upload-purchase-order',
  templateUrl: './bulk-upload-purchase-order.component.html',
  styleUrls: ['../../../../../bulk-style.css']
})
export class BulkUploadPurchaseOrderComponent  extends SpreadsheetFileHandler{
  currentUser: UserModel;
  isLoaderResult:boolean = false;
  file: File;
  uploadFileName: string;
  uploadFileContent: string;
  isAdminGroupUser: boolean = false;

  constructor(
    protected readonly datePipe: DatePipe,
    protected readonly spreadsheetService:SpreadsheetValidateService,
    protected readonly notify: NotificationService,
    private readonly crudPoService:CrudPurchaseOrderService,
    private readonly commonService:CommonservicesService
  )
  {
    super(spreadsheetService, datePipe, notify);
    this.currentUser = JSON.parse(sessionStorage.getItem("user"));
    this.isAdminGroupUser = this.currentUser.isAdminGroupUser;
  }

  downloadSampleFileForBulkPo(){
    this.downloadFileHelper(this.crudPoService.getSampleForBulkPoUpload(), "SampleBulkPurchaseOrder");
  }

  onPurchaseOrderFileUpload(event: any) {
    this.handleFileUpload(
      event,
      (file) => this.uploadToAPI(file),
      "upload_bulkPO"
    );
   }

     uploadToAPI(file: File)
  {
     this.uploadFileHelper(
      (formData) =>
        this.crudPoService.uploadFileToBulkCreatePos(formData),
      file,
      (fileName) => this.downloadResultFile(fileName)
    );
  }

    downloadResultFile(fileName: string): void {
      this.downloadResultFileHelper(
      this.commonService.getResultFileByFileName(fileName),
      fileName,
      "Bulk Purchase order creation result file download process started.",
      "Error in downloading the bulk purchase order file"
    );
   }
   
  }


  


